<onsip-header-main>
  <onsip-header-page-title>{{ "ONSIP_I18N.PARKING_LOT" | translate }}</onsip-header-page-title>
</onsip-header-main>
<div class="mat-body-2">{{ pricingText }}</div>

<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form [formGroup]="parkLotForm">
    <mat-horizontal-stepper
      #stepper
      linear
      class="onsip-stepper-disabled-header onsip-header-full-width"
    >
      <mat-step #parkingLotSettingsStep [stepControl]="parkLotForm" completed="false">
        <ng-template matStepLabel>{{ "ONSIP_I18N.PARKING_LOT_SETTINGS" | translate }}</ng-template>
        <div class="mat-headline-5">{{ "ONSIP_I18N.PARKING_LOT_SETTINGS" | translate }}</div>
        <ng-template *ngTemplateOutlet="parkingLotSettings"></ng-template>
        <span class="navigation-buttons no-back">
          <button mat-button type="button" color="primary" class="cancel-button" (click)="cancel()">
            {{ "ONSIP_I18N.CANCEL" | translate }}
          </button>
          <button
            type="button"
            mat-flat-button
            color="primary"
            [attr.data-cy]="E2eLocators.ADMIN_PARKING_LOT_GO_TO_CALLER_SETTINGS_BUTTON"
            (click)="goToCallerSettings()"
          >
            {{ "ONSIP_I18N.NEXT" | translate }}
          </button>
        </span>
      </mat-step>
      <mat-step #callerSettingsStep [stepControl]="parkLotForm" completed="false">
        <ng-template matStepLabel>{{
          "ONSIP_I18N.PARKING_LOT_CALLER_SETTINGS" | translate
        }}</ng-template>
        <div class="mat-headline-5">{{ "ONSIP_I18N.PARKING_LOT_CALLER_SETTINGS" | translate }}</div>
        <ng-template *ngTemplateOutlet="callerSettings"></ng-template>
        <div class="step-actions">
          <div>
            @if ((mobileView | async) === false) {
            <button
              mat-stroked-button
              mat-button
              type="button"
              color="primary"
              class="prev-step-btn"
              (click)="prevStep()"
            >
              Previous step
            </button>
            }
          </div>
          <span class="navigation-buttons no-back">
            <button
              mat-button
              type="button"
              color="primary"
              class="cancel-button"
              (click)="cancel()"
            >
              {{ "ONSIP_I18N.CANCEL" | translate }}
            </button>
            @if (mobileView | async) {
            <button
              mat-stroked-button
              mat-button
              type="button"
              color="primary"
              class="prev-step-btn"
              (click)="prevStep()"
            >
              Previous step
            </button>
            }
            <button
              type="submit"
              mat-flat-button
              color="primary"
              [attr.data-cy]="E2eLocators.ADMIN_PARKING_LOT_GO_TO_REVIEW_BUTTON"
              (click)="goToReview()"
            >
              {{ "ONSIP_I18N.NEXT" | translate }}
            </button>
          </span>
        </div>
      </mat-step>
      <mat-step #reviewStep>
        <ng-template matStepLabel>{{ "ONSIP_I18N.REVIEW" | translate }}</ng-template>
        <ng-template *ngTemplateOutlet="reviewParkLot"></ng-template>
        @if (!edit) {
        <div class="step-actions">
          <div>
            @if ((mobileView | async) === false) {
            <button
              mat-stroked-button
              mat-button
              type="button"
              color="primary"
              class="prev-step-btn"
              (click)="prevStep()"
            >
              Previous step
            </button>
            }
          </div>
          <span class="navigation-buttons no-back">
            <button
              mat-button
              type="button"
              color="primary"
              class="cancel-button"
              (click)="cancel()"
            >
              {{ "ONSIP_I18N.CANCEL" | translate }}
            </button>
            @if (mobileView | async) {
            <button
              mat-stroked-button
              mat-button
              type="button"
              color="primary"
              class="prev-step-btn"
              (click)="prevStep()"
            >
              Previous step
            </button>
            }
            <button
              type="button"
              mat-flat-button
              color="primary"
              [attr.data-cy]="E2eLocators.ADMIN_PARKING_LOT_GO_TO_SUBMIT_BUTTON"
              (click)="save()"
            >
              Save & finish setup
            </button>
          </span>
        </div>
        }
      </mat-step>
    </mat-horizontal-stepper>
    <ng-template #parkingLotSettings>
      <div class="parking-lot-settings onsip-grid-placement">
        <div class="first-column">
          <div class="m-b-12">
            <div class="mat-body-1 field-label-margin">
              {{ "ONSIP_I18N.PARKING_LOT_NAME" | translate }}
            </div>
            <mat-form-field appearance="outline">
              <input
                matInput
                required
                formControlName="name"
                autocomplete="off"
                [attr.data-cy]="E2eLocators.ADMIN_PARKING_LOT_NAME"
              />
              <mat-error>{{
                getGenericNameError(parkLotForm.controls.name, "ONSIP_I18N.NAME" | translate)
              }}</mat-error>
            </mat-form-field>
          </div>
          <div class="m-b-12">
            <div class="mat-body-1 field-label-margin">
              {{ "ONSIP_I18N.PARKING_LOT_NUMBER_OF_CHANNELS" | translate }}
            </div>
            <div class="field-grid-block">
              <div class="channels filed-grid">
                <mat-form-field appearance="outline">
                  <mat-select
                    formControlName="channelLimit"
                    [attr.data-cy]="E2eLocators.ADMIN_PARKING_LOT_CHANNEL_LIMIT_SELECT"
                  >
                    @for (count of numberOfChannels; track count) {
                    <mat-option [value]="count" (click)="calculateCurrentPrice(count)">
                      {{ count }}
                    </mat-option>
                    }
                  </mat-select>
                  <mat-error>{{
                    getGenericRequiredError(parkLotForm.controls.channelLimit, "Field")
                  }}</mat-error>
                </mat-form-field>
                <span class="price mat-body-1"> {{ currentPrice | currency }}</span>
              </div>
            </div>
          </div>
          <div class="m-b-12 pin">
            <div class="mat-body-1 field-label-margin">
              {{ "ONSIP_I18N.PARKING_LOT_RETRIEVAL_PIN" | translate }}
            </div>
            <div class="field-grid-block">
              <mat-form-field appearance="outline" class="filed-grid">
                <input
                  matInput
                  formControlName="pin"
                  autocomplete="off"
                  [attr.data-cy]="E2eLocators.ADMIN_PARKING_LOT_PIN"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="second-column">
          <h3>{{ "ONSIP_I18N.PARKING_LOT_DESTINATION" | translate }}</h3>
          <div class="m-b-12">
            <div class="mat-body-1 field-label-margin">
              {{ "ONSIP_I18N.SIP_ADDRESS" | translate }}
            </div>
            <onsip-sip-address-field #parkSipAddress formControlName="parkSipAddress">
            </onsip-sip-address-field>
          </div>
          <div class="m-b-28">
            <div class="mat-body-1 field-label-margin">
              {{ "ONSIP_I18N.EXTENSIONS" | translate }}
            </div>
            <onsip-extensions-list
              #extensionsList
              [excludedExtensions]="parkLotForm.controls.retrieverExtensions.value"
              formControlName="extensions"
            >
            </onsip-extensions-list>
          </div>
        </div>
        <div class="third-column">
          <h3>{{ "ONSIP_I18N.PARKING_LOT_RETRIEVAL_DESTINATION" | translate }}</h3>
          <div class="m-b-12">
            <div class="mat-body-1 field-label-margin">
              {{ "ONSIP_I18N.PARKING_LOT_RETRIEVAL_ADDRESS" | translate }}
            </div>
            <onsip-sip-address-field #retrieverSipAddressField formControlName="retrieveSipAddress">
            </onsip-sip-address-field>
          </div>
          <div class="m-b-28">
            <div class="mat-body-1 field-label-margin">
              {{ "ONSIP_I18N.EXTENSIONS" | translate }}
            </div>
            <onsip-extensions-list
              #retrieverExtensionsList
              [excludedExtensions]="parkLotForm.controls.extensions.value"
              formControlName="retrieverExtensions"
            >
            </onsip-extensions-list>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #callerSettings>
      <div class="caller-settings onsip-grid-placement">
        <div class="first-column">
          <div class="m-b-12 music-source">
            <div class="mat-body-1 field-label-margin">
              {{ "ONSIP_I18N.PARKING_LOT_MUSIC" | translate }}
            </div>
            <mat-form-field
              appearance="outline"
              onsip-form-field-flush-outline
              onsip-hide-subscript-wrapper
            >
              <mat-select formControlName="musicSourceId">
                @for (musicSource of musicSources$ | async; track musicSource) {
                <mat-option [value]="musicSource.musicSourceId">
                  {{ musicSource.name }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <button
              mat-button
              color="primary"
              type="button"
              class="add-item-btn"
              (click)="createMusicSource()"
            >
              <mat-icon>add</mat-icon>
              <span> {{ "ONSIP_I18N.ADD_MUSIC_SOURCE" | translate }}</span>
            </button>
          </div>
          <div class="m-b-12">
            <div class="mat-body-1 field-label-margin">
              {{ "ONSIP_I18N.PARKING_LOT_MANUAL_RETURN_BTN" | translate }}
            </div>
            <div class="field-grid-block">
              <mat-form-field appearance="outline" class="filed-grid">
                <mat-select formControlName="manualReturnDtmf">
                  @for (btn of manualReturnBtns; track btn) {
                  <mat-option [value]="btn">
                    {{ btn ? btn : ("ONSIP_I18N.NONE" | translate) }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="second-column">
          <div class="m-b-12">
            <div class="mat-body-1 field-label-margin">
              {{ "ONSIP_I18N.PARKING_LOT_AUTO_RETURN" | translate }}
            </div>
            <mat-form-field appearance="outline">
              <mat-select formControlName="autoReturnTimeout">
                @for (time of autoReturnTimeout; track time) {
                <mat-option [value]="time"> {{ time }} seconds </mat-option>
                }
              </mat-select>
              <mat-error>{{
                getGenericRequiredError(parkLotForm.controls.autoReturnTimeout, "Field")
              }}</mat-error>
            </mat-form-field>
          </div>
          <div class="m-b-12">
            <div class="mat-body-1 field-label-margin failover-address">
              {{ "ONSIP_I18N.FAILOVER_ADDRESS" | translate }}
              <mat-icon
                class="failover-address-tooltip"
                [matTooltip]="'ONSIP_I18N.FAILOVER_ADDRESS_TOOLTIP_TEXT' | translate"
                matTooltipClass="onsip-tooltip-background"
                matTooltipPosition="above"
              >
                help_outline
              </mat-icon>
            </div>
            <onsip-address-autocomplete
              [attr.data-cy]="E2eLocators.ADMIN_PARKING_LOT_FAILOVER"
              formControlName="returnAddress"
              placeholder="Search for a Failover"
              [errorMessage]="getGenericRequiredError(parkLotForm.controls.returnAddress, 'Field')"
            >
            </onsip-address-autocomplete>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #reviewParkLot let-column>
      <div class="review-block">
        <span class="mat-headline-5">{{ "ONSIP_I18N.REVIEW" | translate }}</span>
        <span class="button-wrapper">
          @if (!edit) {
          <button
            mat-stroked-button
            mat-button
            type="button"
            color="primary"
            class="cancel-button"
            (click)="toggleEditInfo()"
          >
            {{ "ONSIP_I18N.EDIT_INFO" | translate }}
          </button>
          } @if (edit) {
          <button
            mat-stroked-button
            mat-button
            type="button"
            color="primary"
            class="cancel-button"
            (click)="toggleEditInfo()"
          >
            {{ "ONSIP_I18N.CANCEL_EDITS_BTN" | translate }}
          </button>
          }
        </span>
      </div>
      @if (!edit) {
      <div class="review">
        <h2>{{ "ONSIP_I18N.PARKING_LOT_SETTINGS" | translate }}</h2>
        <div class="parking-lot-settings-review onsip-grid-placement">
          <div class="first-column">
            <div class="m-b-28">
              <div class="mat-body-1 review-label-margin">
                {{ "ONSIP_I18N.PARKING_LOT_NAME" | translate }}
              </div>
              <div>{{ parkLotForm.controls.name.value }}</div>
            </div>
            <div class="m-b-28">
              <div class="mat-body-1 review-label-margin">
                {{ "ONSIP_I18N.PARKING_LOT_NUMBER_OF_CHANNELS" | translate }}
              </div>
              <div>{{ parkLotForm.controls.channelLimit.value }}</div>
            </div>
            <div class="m-b-28">
              <div class="mat-body-1 review-label-margin">
                {{ "ONSIP_I18N.PARKING_LOT_RETRIEVAL_PIN" | translate }}
              </div>
              <div>
                {{
                  parkLotForm.controls.pin.value
                    ? parkLotForm.controls.pin.value
                    : ("ONSIP_I18N.NONE" | translate)
                }}
              </div>
            </div>
          </div>
          <div class="second-column">
            <h3>{{ "ONSIP_I18N.PARKING_LOT_DESTINATION" | translate }}</h3>
            <div class="m-b-28">
              <div class="mat-body-1 review-label-margin">
                {{ "ONSIP_I18N.SIP_ADDRESS" | translate }}
              </div>
              <div>{{ parkLotForm.controls.parkSipAddress.value }}&#64;{{ domain }}</div>
            </div>
            <div class="m-b-28">
              <div class="mat-body-1 review-label-margin">
                {{ "ONSIP_I18N.EXTENSIONS" | translate }}
              </div>
              @if (parkLotForm.controls.extensions.value.length) {
              <div>
                @for (extension of parkLotForm.controls.extensions.value; track extension) {
                <div>
                  {{ extension | formatExtensions }}
                </div>
                }
              </div>
              } @else { No extensions added }
            </div>
          </div>
          <div class="third-column">
            <h3>{{ "ONSIP_I18N.PARKING_LOT_RETRIEVAL_DESTINATION" | translate }}</h3>
            <div class="m-b-28">
              <div class="mat-body-1 review-label-margin">
                {{ "ONSIP_I18N.PARKING_LOT_RETRIEVAL_ADDRESS" | translate }}
              </div>
              <div>{{ parkLotForm.controls.retrieveSipAddress.value }}&#64;{{ domain }}</div>
            </div>
            <div class="m-b-28">
              <div class="mat-body-1 review-label-margin">
                {{ "ONSIP_I18N.EXTENSIONS" | translate }}
              </div>
              @if ( parkLotForm.controls.retrieverExtensions.value.length) {
              <div>
                @for (retrieverExtension of parkLotForm.controls.retrieverExtensions.value; track
                retrieverExtension) {
                <div>
                  {{ retrieverExtension | formatExtensions }}
                </div>
                }
              </div>
              } @else { No extensions added }
            </div>
          </div>
        </div>
        <mat-divider class="divider"></mat-divider>
        <h2>{{ "ONSIP_I18N.PARKING_LOT_CALLER_SETTINGS" | translate }}</h2>
        <div class="caller-settings-review onsip-grid-placement">
          <div class="first-column">
            <div class="m-b-28">
              <div class="mat-body-1 review-label-margin">
                {{ "ONSIP_I18N.PARKING_LOT_MUSIC" | translate }}
              </div>
              <div>{{ parkLotForm.controls.musicSourceName.value }}</div>
            </div>
            <div class="m-b-28">
              <div class="mat-body-1 review-label-margin">
                {{ "ONSIP_I18N.PARKING_LOT_MANUAL_RETURN_BTN" | translate }}
              </div>
              <div>
                {{
                  parkLotForm.controls.manualReturnDtmf.value
                    ? parkLotForm.controls.manualReturnDtmf.value
                    : ("ONSIP_I18N.NONE" | translate)
                }}
              </div>
            </div>
          </div>
          <div class="second-column">
            <div class="m-b-28">
              <div class="mat-body-1 review-label-margin">
                {{ "ONSIP_I18N.PARKING_LOT_AUTO_RETURN" | translate }}
              </div>
              <div>{{ parkLotForm.controls.autoReturnTimeout.value }} seconds</div>
            </div>
            <div class="m-b-28">
              <div class="mat-body-1 review-label-margin">
                {{ "ONSIP_I18N.FAILOVER_ADDRESS" | translate }}
              </div>
              <div>{{ failoverName }}</div>
            </div>
          </div>
        </div>
      </div>
      } @else {
      <div class="edit">
        <h2>{{ "ONSIP_I18N.PARKING_LOT_SETTINGS" | translate }}</h2>
        <ng-template *ngTemplateOutlet="parkingLotSettings"></ng-template>
        <mat-divider class="divider"></mat-divider>
        <h2>{{ "ONSIP_I18N.PARKING_LOT_CALLER_SETTINGS" | translate }}</h2>
        <ng-template *ngTemplateOutlet="callerSettings"></ng-template>
        <span class="navigation-buttons no-back">
          <button mat-button type="button" color="primary" class="cancel-button" (click)="cancel()">
            {{ "ONSIP_I18N.CANCEL" | translate }}
          </button>
          <button type="button" mat-flat-button color="primary" (click)="save()">
            {{ "ONSIP_I18N.SAVE" | translate }}
          </button>
        </span>
      </div>
      }
    </ng-template>
  </form>
</onsip-loading-container>
